import { render, staticRenderFns } from "./StatementPreviewDialog.vue?vue&type=template&id=22fc645a"
import script from "./StatementPreviewDialog.vue?vue&type=script&lang=js"
export * from "./StatementPreviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports